import FormattedMessage from 'I18n/components/FormattedMessage';
import { UnreachableI18nCaseError } from '../../utils/i18nUtils';
import { jsx as _jsx } from "react/jsx-runtime";
export function ApprovalRequestAccessModalI18n(props) {
  const {
    approvalType
  } = props;
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.MARKETING_EMAIL"
        });
      }
    case 'LANDING_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.LANDING_PAGE"
        });
      }
    case 'SITE_PAGE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.SITE_PAGE"
        });
      }
    case 'BLOG_POST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.BLOG_POST"
        });
      }
    case 'DEAL':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.DEAL"
        });
      }
    case 'KNOWLEDGE_ARTICLE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.KNOWLEDGE_ARTICLE"
        });
      }
    case 'QUOTE':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.QUOTE"
        });
      }
    case 'SOCIAL_BROADCAST':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalRequestAccess.modal.body.SOCIAL_BROADCAST"
        });
      }
    default:
      throw new UnreachableI18nCaseError(approvalType);
  }
}
export default ApprovalRequestAccessModalI18n;